const review = {
  title: 'How do you like the app?',
  starHint: '1 = not great, 5 = love it',
  commentPlaceholder: 'Suggestions for improvement (optional)',
  submit: 'Submit',
};

export default review;
